var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i-table',{attrs:{"stripe":"","data":_vm.list,"columns":_vm.titles}}),_c('div',{staticClass:"paging_style"},[_c('Page',{attrs:{"size":"small","show-total":"","show-elevator":"","current":_vm.query.pageNumber,"page-size":_vm.query.pageSize,"total":_vm.total},on:{"on-change":_vm.handlePageNumberChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }